export const loadProspectsSelector = ({ loadProspects }) => loadProspects;
